export default __webpack_public_path__ + "static/media/PasswordChanged.d4994661.svg";